export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";